export default {
    locale: '',
    currency: '',
}
